export default {
    locale: '',
    currency: '',
}
